import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { INVITATION_STATUS } from '@app/modules/invitations/consts/status';
import { IAllInvitation } from '@app/modules/invitations/interface/invitation';
import { InvitationsActions } from '@app/modules/invitations/store/invitations.actions';
import { UserModel } from '@app/modules/user/model/user';
import { UserState } from '@app/modules/user/store/user.state';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-invitations-part',
  templateUrl: './invitations-part.component.html',
  styleUrls: ['./invitations-part.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationsPartComponent implements OnInit {
  @Input() invitations: IAllInvitation[];

  @Select(UserState.model)
  public userModel$: Observable<UserModel>;

  public INVITATION_STATUS = INVITATION_STATUS;
  constructor(private store: Store) {}

  ngOnInit(): void {}

  accept(invitationId: number): void {
    this.store.dispatch(new InvitationsActions.AcceptInvitation(invitationId));
  }

  decline(invitationId: number): void {
    this.store.dispatch(new InvitationsActions.DeclineInvitation(invitationId));
  }

  cancel(invitationId: number): void {
    this.store.dispatch(new InvitationsActions.CancelInvitation(invitationId));
  }
}
